let now = new Date();
let setDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2);

let myMonth = document.querySelector('#setMonth'),
    myDate = document.querySelector('#setDate');

// console.log(now.getFullYear(), now.getMonth(), now.getDate());
// console.log(setDate);

myMonth.src = `img/${setDate.getMonth() + 1}.png`;
myDate.src = `img/${setDate.getDate()}.png`;